import { Card, Input } from "antd";
import React, { useContext, useEffect, useState } from "react";
import FetchContext from "../../../contexts/fetch";
import FlowContext from "../../../contexts/flowContext";
import { DynamicForm, DynamicFormUtilsDataContext } from "../../DynamicForm";
import styles from "../manager.module.css";
import EdgeList from "./EdgeList";
import NodeList from "./NodeList";
import FlowInfo from "./FlowInfo";

const Flow = () => {
  const [shouldRender, setShouldRender] = useState(false);

  const [flowState, flowDispatcher] = useContext(FlowContext);
  const [fetchContext] = useContext(FetchContext);

  const dynamicFormUtilsDataContext = useContext(DynamicFormUtilsDataContext);

  useEffect(() => {
    setShouldRender(
      !flowState.nodes.filter((node) => node.selected).length &&
        !flowState.edges.filter((edge) => edge.selected).length &&
        flowState.flowLoaded
    );
  }, [flowState]);

  const handleGlobalParameterChange = function (data) {
    if (JSON.stringify(data) !== JSON.stringify(flowState.globalParameters)) {
      flowDispatcher({
        type: "update-global-parameters",
        globalParameters: data,
      });
    }
  };

  return (
    shouldRender && (
      <div>
        <div className={styles.header}>
          <Card
            className={styles.section}
            title={<span className={styles.section_title}>Flow info</span>}
            bordered={false}
            style={{ width: 300 }}
          >
            <FlowInfo flowState={flowState} />
          </Card>
        </div>
        <div className={styles.body}>
          <div className={styles.module}>
            <Card
              className={styles.section}
              title={
                <span className={styles.section_title}>Global Parameters</span>
              }
              bordered={false}
              style={{ width: 300 }}
            >
              <DynamicForm
                formData={flowState.globalParameters}
                onParameterChange={handleGlobalParameterChange}
                parametersModel={
                  fetchContext.clientConfig.formTemplateGlobalParameters
                }
                utilsData={dynamicFormUtilsDataContext}
              />
            </Card>
          </div>

          <div className={styles.module}>
            <Card
              className={styles.section}
              title={
                <span className={styles.section_title}>Tous les noeuds</span>
              }
              bordered={false}
            >
              <NodeList />
            </Card>
          </div>

          <div className={styles.module}>
            <Card
              className={styles.section}
              title={
                <span className={styles.section_title}>Tous les liens</span>
              }
              bordered={false}
            >
              <EdgeList />
            </Card>
          </div>
        </div>
      </div>
    )
  );
};

export default Flow;
